export default __webpack_public_path__ + "static/media/doctor@3x.f34361ec.jpg";